module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/transform.js
// module id = 1161
// module chunks = 3